<template>
    <!-- <FilterCompoennt :data="data" :notion="'https://www.notion.com/ko'" /> -->
    <FilterCompoennt :data="data" />
    <div class="board_list">
        <ul v-if="data.list.length > 0">
            <li :class="{ open: activeIndex.includes(post.idx) }" v-for="(post, idx) of data.list" :key="post.idx">
                <div class="row" @click="openPost(post.idx)">
                    <div class="col">
                        <span class="num">{{ data.totalCnt - ((+this.$route.query.page || 1) - 1) *
                            (+this.$route.query.size || 10) - idx }}</span>
                    </div>
                    <div class="col title">
                        <span v-if="post.secondCategoryName" class="category">[{{ post.secondCategoryName.trim()
                        }}]</span>
                        <p>{{ post.question }}</p>
                        <span v-if="post.secret" class="secret-icon">
                            <img src="@/assets/ic-secret.png" alt="" />
                        </span>
                    </div>
                    <div class="col dropdown_button">
                        <img src="@/assets/list_dropdown_icon.png" alt="" />
                    </div>
                </div>
                <div class="row row_content">
                    <div class="col"></div>
                    <div class="col content">
                        <p v-html="post.answer"></p>
                        <div class="hash_group" v-if="post.hashtag">
                            <span v-for="(hash, idx) in post.hashtag.split(',')" :key="idx" @click="tagSearch(hash)">
                                #{{ hash }} </span>
                        </div>
                    </div>
                    <div class="col"></div>
                </div>
            </li>
        </ul>
        <p class="no-data" v-else>등록된 게시글이 없습니다.</p>
    </div>
    <PaginationComponent :data="data" />
</template>

<script>
import FilterCompoennt from '@/components/FilterCompoennt.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';

export default {
    components: {
        FilterCompoennt,
        PaginationComponent,
    },
    props: {
        data: {},
        modalOpen: {},
    },
    data() {
        return {
            activeIndex: [],
        };
    },
    methods: {
        openPost(idx) {
            if (!this.activeIndex.includes(idx)) {
                this.activeIndex.push(idx);
            } else {
                this.activeIndex = this.activeIndex.filter((el) => el !== idx);
            }
        },
        tagSearch(tag) {
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    page: 1,
                    searchType: 'hashtag',
                    keyword: tag,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    color: #666;
}

.board_list {
    width: 100%;
    border-top: 1px solid var(--black1);

    ul {
        width: 100%;

        li {
            &.open {
                .row.row_content {
                    display: flex;
                }

                .dropdown_button {
                    flex-shrink: 0;
                    img {
                        transform: rotate(180deg);
                    }
                }
            }

            list-style: none;
            border-bottom: 1px solid var(--border-color1);

            .row {
                width: 100%;
                height: 90px;
                display: flex;
                justify-content: flex-start;
                align-items: center;

                @media screen and (max-width: 768px) {
                    height: 70px;
                }

                &.row_content {
                    display: none;
                    height: auto;
                    background: #fffbf8;
                    border-top: 1px solid var(--border-color1);
                }

                .col.content {
                    padding: 40px 0 30px;
                    padding-left: 50px;

                    @media screen and (max-width: 768px) {
                        padding-left: 0;
                    }

                    p {
                        line-height: 30px;
                        font-size: 16px;
                        color: var(--black2);
                    }

                    .hash_group {
                        margin-top: 60px;
                        display: flex;
                        gap: 10px;

                        @media screen and (max-width: 768px) {
                            margin-top: 40px;
                        }

                        span {
                            cursor: pointer;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            padding: 0 18px;
                            height: 32px;
                            border: 1px solid #b2b2b2;
                            color: #b3b3b3;
                            border-radius: 16px;

                            &:hover {
                                color: var(--orange);
                                border-color: var(--orange);
                            }
                        }
                    }
                }
            }

            &:hover {
                background: #fffbf8;

                .col.title p {
                    color: var(--orange);
                    text-decoration: underline;
                }
            }

            .col {
                &:first-child {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex: 0 0 100px;

                    @media screen and (max-width: 768px) {
                        width: 40px;
                        flex: none;
                    }

                    .num {
                        font-family: 'Play', sans-serif;
                        font-weight: 700;
                        font-size: 18px;
                        color: #888;
                    }
                }

                &.title {
                    padding-left: 50px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    min-width: 0;

                    @media screen and (max-width: 1024px){
                        padding-left: 0;
                    }

                    @media screen and (max-width: 768px) {
                        margin-right: 10px;
                        padding-left: 0;
                        width: 70%;
                    }

                    .category {
                        font-size: 18px;
                        color: var(--orange);
                        flex-shrink: 0;

                        @media screen and (max-width: 768px) {
                            font-size: 16px;
                            flex: none;
                        }
                    }

                    p {
                        font-size: 18px;
                        color: var(--black1);
                        letter-spacing: -0.03em;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;

                        @media screen and (max-width: 768px) {
                            font-size: 16px;
                        }
                    }

                    .attack-icon {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex: none;
                    }
                }

                &:last-child {
                    margin-left: auto;
                    width: 200px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    @media screen and (max-width: 768px) {
                        width: auto;
                        flex: none;
                    }

                    .date {
                        font-size: 16px;
                        color: #888;
                    }
                }

                &.dropdown_button {
                    width: 120px;
                    cursor: pointer;
                    flex-shrink: 0;

                    @media screen and (max-width: 768px) {
                        width: 50px;
                    }
                }
            }
        }
    }
}
</style>
